import React from "react";
import { Skeleton, Flex, Grid } from "@mantine/core";
import { Section } from "../Container/Section";
import { SectionTitleWithExp } from "../customTypo/SectionTitleWithExp";
import { CardContainerRetro } from "../Container/CardContainerRetro";
import colorsCustom from "../../designTokens/colorsCustom";

export const GridSkeleton = ({ isMobile, title }) => {
	// 다양한 사용자명 길이를 시뮬레이션하기 위한 고정 배열
	const userNameWidths = [60, 80, 70, 90, 65, 85, 75, 95];
	
	return (
		<Section>
			<SectionTitleWithExp title={title} />
			<CardContainerRetro
				p={isMobile ? "16px" : "48px 32px 48px 24px"}
				bg={colorsCustom.paper}
				weight="bold"
				rd={16}
				style={{ position: "relative" }}
			>
				<Grid w="100%" wrap="wrap" gutter="48px">
					{Array.from({ length: 8 }, (_, index) => (
						<Grid.Col span={isMobile ? 6 : 3} key={index}>
							<Flex
								w="100%"
								direction="column"
								align="center"
								justify="center"
								gap="8px"
								style={{ cursor: "pointer" }}
							>
								{/* 프로필 이미지 Skeleton */}
								<Skeleton
									height={50}
									width={50}
									circle
								/>
								
								{/* 사용자명 Skeleton - 고정 배열로 다양성 제공 */}
								<Skeleton 
									height={isMobile ? 16 : 20} 
									width={userNameWidths[index]}
								/>
								
								{/* 댓글 수 Skeleton */}
								<Flex align="center" gap={4}>
									<Skeleton height={18} width={20} />
									<Skeleton height={18} width={60} />
								</Flex>
							</Flex>
						</Grid.Col>
					))}
				</Grid>
			</CardContainerRetro>
		</Section>
	);
}; 